/* eslint-disable react/destructuring-assignment, react/prop-types, react/require-optimization */

import {applyMiddleware, createStore} from "redux";
import ErrorBoundary from "../../../shared/components/ErrorBoundary";
import PropTypes from "prop-types";
import {Provider} from "react-redux";
import React from "react";
import {initializeStore} from "./stateInitializer";
import promise from "redux-promise";
import reducer from "../../../reducers";

export default class ContainerWrapper extends React.Component {
  static propTypes = {
    "apiToken": PropTypes.string,
    "customerId": PropTypes.string,
    "params": PropTypes.object.isRequired,
    "renderCouponBanner": PropTypes.bool
  };

  static defaultProps = {
    "apiToken": null,
    "customerId": null,
    "renderCouponBanner": false
  };

  constructor (props) {
    super(props);

    this.store = this.createStoreWithMiddleware(reducer, initializeStore(props));
    const currentPathname = window.location.pathname;
    const stampedProps = Object.assign({...props}, {"createdAt": Date.now()});

    this.state = {
      "currentPropsCacheKey": currentPathname,
      "propsCache": {[currentPathname]: stampedProps}
    };
  }

  createStoreWithMiddleware = applyMiddleware(promise)(createStore);

  fetchNewProps = (path, callback) => {
    const {propsCache} = this.state;
    jQuery.get(path).done((data) => {
      data.createdAt = Date.now();
      this.setState(
        {
          "currentPropsCacheKey": path,
          "propsCache": Object.assign(
            {...propsCache},
            {[path]: data}
          )
        },
        callback
      );
    });
  }

  render () {
    const {fetchNewProps, store} = this;
    const {currentPropsCacheKey, propsCache} = this.state;

    return (
      <ErrorBoundary>
        <Provider store={store}>
          {React.cloneElement(this.props.children, {
            ...propsCache[currentPropsCacheKey],
            fetchNewProps,
            propsCache
          })}
        </Provider>
      </ErrorBoundary>
    );
  }
}
